module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabBox"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    },
    attrs: {
      "data": _vm.tableData,
      "highlight-current-row": ""
    },
    on: {
      "current-change": _vm.currentChange,
      "row-click": _vm.check_risk
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "title",
      "align": "center",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "referenceCode",
      "align": "center",
      "label": "文号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "category",
      "align": "center",
      "label": "类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.category == 1) ? _c('span', [_vm._v("法律法规规章制度")]) : _vm._e(), _vm._v(" "), (scope.row.category == 2) ? _c('span', [_vm._v("重污染天气")]) : _vm._e(), _vm._v(" "), (scope.row.category == 3) ? _c('span', [_vm._v("突发环境事件")]) : _vm._e(), _vm._v(" "), (scope.row.category == 4) ? _c('span', [_vm._v("其他")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orgName",
      "align": "center",
      "label": "上传机构"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "发文日期"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatTime(scope.row.releaseDate)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "文件"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "color": "#1f2d3d",
            "text-decoration": "underline"
          },
          on: {
            "click": function($event) {
              _vm.download(scope.row.id)
            }
          }
        }, [_vm._v(_vm._s(scope.row.fileName))])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40e86f16","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/manage/guidefile/heavypoll.vue
// module id = 1216
// module chunks = 2